import { createSelector } from "reselect";

const list = state => state.list;
const nonSodeSelected = state => state.selectedNonSode;
const loading = state => state.loading;
const loaded = state => state.loaded;
const listItems = createSelector(list, list => list.items);

const fields = createSelector(list, list => list.fields);

const pagination = createSelector(list, list => list.pagination);

const nextPage = createSelector(pagination, pg => pg.next);

const previousPage = createSelector(pagination, pg => pg.previous);

const actualPage = createSelector(pagination, pg => pg.actualPage);

const countItems = createSelector(pagination, pg => pg.count);

const pages = createSelector(pagination, pg => pg.pages);

const nonSodeSelectedItem = createSelector(nonSodeSelected, listItems, (id, list) => list[id]);

const listItemsArray = createSelector(listItems, items => Object.values(items));

export default {
    list,
    nonSodeSelected,
    loading,
    loaded,
    listItems,
    listItemsArray,
    fields,
    pagination,
    nextPage,
    previousPage,
    actualPage,
    countItems,
    pages,
    nonSodeSelectedItem
};
